import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const beginnerGuides = [
  { text: "Cos'è Itaobuy Spreadsheet", slug: '/guida-itaobuy-sheet-2026' },
  { text: 'Come iniziare', slug: '/come-usare-itaobuy-principianti' },
  { text: 'Come leggere informazioni prodotto', slug: '/come-usare-itaobuy-principianti' },
];

const advancedGuides = [
  { text: 'Strategie ricerca prodotti', slug: '/strategie-ricerca-prodotti' },
  { text: 'Analisi prezzi', slug: '/strategie-ricerca-prodotti' },
  { text: 'Ottimizzazione acquisti', slug: '/strategie-ricerca-prodotti' },
];

const safetyGuides = [
  { text: 'Controllo qualità', slug: '/guida-sicurezza-itaobuy' },
  { text: 'Errori comuni', slug: '/errori-comuni-itaobuy' },
  { text: 'Consigli pratici', slug: '/errori-comuni-itaobuy' },
];

const faqs = [
  {
    q: "Che cos'è Itaobuy Spreadsheet?",
    a: 'È una guida organizzata che permette di analizzare prodotti e informazioni in modo più semplice.',
  },
  {
    q: 'Itaobuy Spreadsheet è gratuito?',
    a: 'Dipende dalle risorse e dagli strumenti utilizzati.',
  },
  {
    q: 'Come posso utilizzare Itaobuy Spreadsheet?',
    a: 'Seguendo una procedura: ricerca → analisi → confronto → verifica → decisione.',
  },
  {
    q: 'Perché utilizzare una guida italiana?',
    a: "Perché gli utenti italiani possono trovare spiegazioni più semplici e informazioni adattate alle loro esigenze.",
  },
];

export function ArticleHub() {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-16 md:py-24 bg-background-100 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 text-center">
            {t('section6.title')}
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-12">{t('section6.subtitle')}</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold text-foreground-800 mb-4 flex items-center gap-2">
                <i className="ri-book-open-line text-accent-500"></i> Guide principianti
              </h3>
              <div className="space-y-2">
                {beginnerGuides.map((g, idx) => (
                  <Link
                    key={idx}
                    to={g.slug}
                    className="block px-4 py-2.5 rounded-lg bg-background-50 text-sm text-foreground-600 hover:text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line mr-1"></i> {g.text}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-foreground-800 mb-4 flex items-center gap-2">
                <i className="ri-bar-chart-line text-accent-500"></i> Guide avanzate
              </h3>
              <div className="space-y-2">
                {advancedGuides.map((g, idx) => (
                  <Link
                    key={idx}
                    to={g.slug}
                    className="block px-4 py-2.5 rounded-lg bg-background-50 text-sm text-foreground-600 hover:text-accent-600 hover:bg-accent-100 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line mr-1"></i> {g.text}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-foreground-800 mb-4 flex items-center gap-2">
                <i className="ri-shield-line text-accent-500"></i> Sicurezza
              </h3>
              <div className="space-y-2">
                {safetyGuides.map((g, idx) => (
                  <Link
                    key={idx}
                    to={g.slug}
                    className="block px-4 py-2.5 rounded-lg bg-background-50 text-sm text-foreground-600 hover:text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line mr-1"></i> {g.text}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="py-16 md:py-24 bg-background-50 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-10 text-center">
            {t('section7.title')}
          </h2>

          <div className="max-w-2xl mx-auto space-y-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group border border-background-200 rounded-xl overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                  <span className="text-sm font-semibold text-foreground-800 pr-4">{faq.q}</span>
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}